<template>
  <div class="horizontal-export contents"></div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
});
</script>

<style lang="scss" scoped>
.horizontal-export {
  width: 100%;
  height: 100%;
  background-color: var(--color-background-normal);
  color: var(--color-text-normal);
}
</style>

<style lang="scss">
h1 {
  font-size: 1.8em;
  margin: 1em 0;
  color: var(--color-text-normal);
}

p {
  font-size: 1.2em;
  line-height: 3em;
  margin: 0;
  min-height: 3em;
  color: var(--color-text-normal);
}

span {
  display: inline-block; // 改ページでルビが離れないようにする
}
</style>
